import { useMutation, UseMutationResult } from 'react-query';
import request from 'app/api/request';

export interface Linkrole {
  uri: string;
  definition: string;
  labels: Record<string, string>;
}

export interface AiPrediction {
  conceptId: string;
  conceptName: string;
  label: string;
  labels: Record<string, Record<string, string>>;
  probability: number;
  f1ScoreTest: number;
  mandatory: boolean;
  linkroles: Linkrole[];
}

export interface AiCellSuggestion {
  row: number;
  col: number;
  predictions: AiPrediction[];
}

export interface TableSuggestions {
  referenceDataSuperId: string;
  suggestions: AiCellSuggestion[];
  truncated?: boolean;
}

export interface SuggestTableTagsInput {
  referenceDataSuperId: string;
  documentSuperId: number;
  cells: { row: number; col: number }[];
  title?: string;
}

export function useSuggestTableTags(): UseMutationResult<TableSuggestions, any, SuggestTableTagsInput> {
  return useMutation(async ({ referenceDataSuperId, documentSuperId, cells, title }: SuggestTableTagsInput) => {
    const res = await request.post(`/gaby/ai-tagging/table/${referenceDataSuperId}`, { documentSuperId, cells, ...(title ? { title } : {}) });
    return res?.data as TableSuggestions;
  });
}
